import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import { ThemeProvider } from './context/ThemeContext';

import AuthLayout from "layouts/auth";
import AdminLayout from "layouts/admin";
import StaffLayout from "layouts/staff";
import VaultLayout from "layouts/vault";
import CustomerLayout from "layouts/customer";

// --- YENİ İMPORT ---
import FastBooking from "views/FastBooking/FastBooking";

const App = () => {
    return (
        <ThemeProvider>
            <AuthProvider>
                <Routes>
                    {/* --- HERKESE AÇIK ROTALAR --- */}
                    <Route path="auth/*" element={<AuthLayout />} />
                    <Route path="hizli-randevu" element={<FastBooking />} />

                    {/* --- YETKİ GEREKTİREN ROTALAR --- */}

                    {/* Admin kapısını Kasa (vault) ve Personel (staff) için de aralıyoruz.
                        Böylece routes.js'de onlara izin verdiğin /admin/.. rotalarına girebilecekler. */}
                    <Route path="admin/*" element={<ProtectedRoute roles={['admin', 'vault', 'staff']}><AdminLayout /></ProtectedRoute>} />

                    <Route path="staff/*" element={<ProtectedRoute roles={['staff', 'admin']}><StaffLayout /></ProtectedRoute>} />

                    {/* Vault (Kasa) kapısını Admin ve Personel (Adisyon, CRM) için aralıyoruz. */}
                    <Route path="vault/*" element={<ProtectedRoute roles={['vault', 'admin', 'staff']}><VaultLayout /></ProtectedRoute>} />

                    {/* Müşteri kapısı zaten sadece müşteriye özel */}
                    <Route path="customer/*" element={<ProtectedRoute roles={['customer']}><CustomerLayout /></ProtectedRoute>} />

                    {/* Varsayılan Yönlendirme */}
                    <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />
                </Routes>
            </AuthProvider>
        </ThemeProvider>
    );
};

export default App;